/* ee-smooth.js — Eyewear Essentials
   Lenis smooth scroll for pointer devices. Off for reduced-motion and for
   touch / coarse-pointer devices, where native scrolling is better and cheaper.
   Requires ee-lenis.min.js (globalThis.Lenis) to have loaded first. */
(function () {
  'use strict';

  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  if (mq('(prefers-reduced-motion: reduce)').matches) return;
  if (mq('(hover: none) and (pointer: coarse)').matches) return;
  if (typeof window.Lenis !== 'function') return;

  var NAMED = '.eeh-colour-track, .eesl-track, .ee-gallery-thumbs';

  /* Horizontal scrollers keep their native wheel/touch handling. */
  function protect(root) {
    var scope = root || document;
    scope.querySelectorAll(NAMED).forEach(function (el) { el.setAttribute('data-lenis-prevent', ''); });
    var main = scope.querySelector ? (scope.querySelector('main') || scope) : scope;
    var all = main.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.scrollWidth <= el.clientWidth + 8 || el.hasAttribute('data-lenis-prevent')) continue;
      var ox = getComputedStyle(el).overflowX;
      if (ox === 'auto' || ox === 'scroll') el.setAttribute('data-lenis-prevent', '');
    }
  }

  var lenis = new window.Lenis({ lerp: 0.1, wheelMultiplier: 1, smoothWheel: true });
  window.eeLenis = lenis;
  (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })(0);
  document.documentElement.classList.add('ee-lenis');

  function headerOffset() {
    var h = document.querySelector('header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    return (pos === 'sticky' || pos === 'fixed') ? h.getBoundingClientRect().height : 0;
  }

  /* In-page anchors: Lenis owns the scroll. Runs in capture so it replaces the
     theme's own scrollIntoView on gallery thumbs (ee-fx.js), keeping the same
     behaviour: centre the image and mirror the hash. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || e.defaultPrevented) return;
    var hash = a.getAttribute('href');
    if (!hash || hash === '#' || a.hasAttribute('data-lenis-ignore')) return;
    if (a.classList.contains('ee-skip')) return;      /* skip link: native jump + focus */
    var id; try { id = decodeURIComponent(hash.slice(1)); } catch (err) { return; }
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    e.stopPropagation();
    var centre = /^Media-/.test(id);
    var offset = centre
      ? -Math.max(0, (window.innerHeight - target.getBoundingClientRect().height) / 2)
      : -headerOffset();
    lenis.scrollTo(target, { offset: offset, duration: 1.1, easing: function (t) { return 1 - Math.pow(1 - t, 3); } });
    try { history.replaceState(null, '', hash); } catch (err) {}
    if (target.hasAttribute('tabindex')) { try { target.focus({ preventScroll: true }); } catch (err) {} }
  }, true);

  function init(root) { try { protect(root); } catch (err) {} }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); lenis.resize(); });
  window.addEventListener('load', function () { lenis.resize(); });
})();
